// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".QcyD[data-v-ba4be3f0]{position:relative;padding:16px}._8fHg[data-v-ba4be3f0]{width:72px;height:72px}.Be4E[data-v-ba4be3f0]{padding-right:16px}.UzIc[data-v-ba4be3f0]{flex-shrink:0;width:450px;border-left:1px solid #e8ebf3}._8tLe[data-v-ba4be3f0]{width:434px;margin-left:16px;border-radius:9px}.qX6g[data-v-ba4be3f0]{margin-bottom:16px;font-size:20px;font-style:normal;font-weight:500;line-height:24px;letter-spacing:-.2px}.bMNo[data-v-ba4be3f0]{margin-bottom:16px;font-weight:400;color:#757575}.xtaW[data-v-ba4be3f0],.bMNo[data-v-ba4be3f0]{font-size:15px;font-style:normal;line-height:20px;letter-spacing:-.23px}.xtaW[data-v-ba4be3f0]{font-weight:600;text-align:left}.C811[data-v-ba4be3f0]{color:#6a1db1}.hT77[data-v-ba4be3f0]{color:#90b4ff}.MGYw[data-v-ba4be3f0]{display:flex;justify-content:flex-end;align-items:center}.fLog[data-v-ba4be3f0]{display:flex;padding-top:16px;border-top:1px solid #e8ebf3}._1AGY[data-v-ba4be3f0]{width:50%}.vpAb[data-v-ba4be3f0]{width:auto}.H6ct[data-v-ba4be3f0]{width:196px}.BuBT[data-v-ba4be3f0]{width:auto;margin-right:8px}@media screen and (min-width:1024px){.CX8T .QcyD[data-v-ba4be3f0]{padding:32px}.CX8T .eVQY[data-v-ba4be3f0]{display:flex}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"comp__wrap": "QcyD",
	"comp__icon": "_8fHg",
	"comp__left": "Be4E",
	"comp__right": "UzIc",
	"comp__video": "_8tLe",
	"comp__title": "qX6g",
	"comp__subtitle": "bMNo",
	"comp__bold": "xtaW",
	"comp__primary": "C811",
	"comp__blue": "hT77",
	"comp__buttonsRight": "MGYw",
	"comp__buttons": "fLog",
	"comp__button": "_1AGY",
	"comp__buttonAllow": "vpAb",
	"comp__buttonAllowOther": "H6ct",
	"comp__buttonCancel": "BuBT",
	"comp": "CX8T",
	"comp__rows": "eVQY"
};
module.exports = ___CSS_LOADER_EXPORT___;
